import { privateCallIncomeModalEntity } from '@/src/entities/private-call-income-modal'
import { privateCallOutcomeModalEntity } from '@/src/entities/private-call-outcome-modal'

export function modalsClose() {
  privateCallIncomeModalEntity.model.modal.close()
  privateCallOutcomeModalEntity.model.modal.close()
}
